/**
 * Toast API con singleton — se puede llamar desde módulos no-React (ej.
 * QueryClient mutation onError) sin arrastrar contexto. La UI que lo
 * renderiza es <Toaster /> en src/shared/components/Toaster.tsx; al
 * montarse registra el dispatcher aquí.
 */

export type ToastVariant = 'info' | 'success' | 'warning' | 'error';

export interface Toast {
  id: string;
  variant: ToastVariant;
  title: string;
  body?: string | undefined;
  durationMs: number;
}

type Dispatcher = (toast: Omit<Toast, 'id'>) => void;

let dispatcher: Dispatcher | null = null;

export function _registerToastDispatcher(fn: Dispatcher | null): void {
  dispatcher = fn;
}

function push(variant: ToastVariant, title: string, body?: string, durationMs = 4000) {
  if (!dispatcher) {
    // eslint-disable-next-line no-console
    console.warn('[toast] no dispatcher yet:', variant, title, body);
    return;
  }
  dispatcher({ variant, title, body, durationMs });
}

export const toast = {
  info: (title: string, body?: string) => push('info', title, body),
  success: (title: string, body?: string) => push('success', title, body),
  warning: (title: string, body?: string) => push('warning', title, body),
  error: (title: string, body?: string) => push('error', title, body, 6000),
};
